import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-63088241-3',
  router
})

Vue.use(VueMeta)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
